"use client"
import React, {useState, useEffect } from 'react'
import { useFormState, useFormStatus } from 'react-dom'
import { ArrowRight, Loader2 } from "lucide-react"
import { sendEmail } from './utils/sendEmail'
import { useReCaptcha } from "next-recaptcha-v3";
import { ContactFormData } from './utils/interface'
import { CheckIcon, XMarkIcon, CheckCircleIcon } from "@heroicons/react/24/solid";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { ContactCopy } from '@/app/copywritting'

interface Props {
  containerRef?: React.RefObject<HTMLDivElement>;
  className?: string;
  height?: number;
}

const ContactForm = (props: Props) => {
    const { containerRef } = props;
    const [scrollProgress, setScrollProgress] = useState(0);
    const [scrollColorChange, setScrollColorChange] = useState(false);
    const { pending } = useFormStatus()
    const { executeRecaptcha } = useReCaptcha();
    const [inputData, setInputData ] = useState("");
    const [formMessage, setFormMessage,] = useState("");
    const [formEmail, setFormEmail] = useState("");

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    // const [state, formAction] = useFormState<FormState, FormData>(
    //     createItem,
    //     initialState
    // );

  const formRef = React.useRef<HTMLFormElement>(null);
//   if (formRef.current && state.success) {
//     formRef.current.reset();
//   }

    const handleSubmit = async(event:React.FormEvent<HTMLFormElement>)=> {
        event.preventDefault()
        const formData : ContactFormData = {email:formEmail,message:formMessage};
        
        const result = await sendEmail(formData)

        if (result?.success) {
            console.log(result.success)
            if (!formRef.current) return;
            setSuccessMessage("Was a success");
            setErrorMessage("");
            formRef.current.reset()
        } else {
            setErrorMessage("Hey, you are already subscribed!");
            setSuccessMessage("");
        }

        // if (!executeRecaptcha) {
        //     console.log("not available to execute recaptcha")
        //     return;
        // }

        // // Generate ReCaptcha token

        


        // const token = await executeRecaptcha("form_submit");
        // console.log("recapcha token", token)
        // console.log("THIRD")
    }  

    const dismissMessages = () => {
        setSuccessMessage("");
        setErrorMessage("");
    };

    // async function handleSubmit(formData: FormData, e: FormEvent) {
    //     e.preventDefault();

    //     // if (!executeRecaptcha) {
    //     //     console.log("not available to execute recaptcha")
    //     //     return;
    //     // }

    //     // // Generate ReCaptcha token
    //     // const token = await executeRecaptcha("form_submit");
    //     // console.log("recapcha token", token)

    //     // const response = await fetch('/api/verify-recaptcha',{
    //     //     method: 'POST',
    //     //     headers: {
    //     //         'Content-Type':'application/json',
    //     //     },
    //     //     body: JSON.stringify({token})
    //     // });

    //     // const data = await response.json();
    //     // if (data.success){
    //     //     console.log("Recaptch DATA Sucess",data)
    //     // } else {
    //     //     console.log("Recaptch DATA Failed",data)
    //     // }
        
    //     const result = await sendEmail(formData)

    //     if (result.success) {
    //     //   toast({
    //     //     title: "Success",
    //     //     description: result.success,
    //     //   })
    //     console.log('SUCCESS')
    //     } else {
    //     //   toast({
    //     //     variant: "destructive",
    //     //     title: "Error",
    //     //     description: result.error,
    //     //   })
    //     console.log('FAILES')
    //     }
    // }
    useEffect(() => {
          const handleScroll = () => {
            const target = containerRef?.current || document.documentElement;      
            const { scrollTop, scrollHeight, clientHeight } = target;
            const totalHeight = scrollHeight - clientHeight;
            const progress = (scrollTop / totalHeight) * 100;
            if (progress >= 82) {
              setScrollColorChange(true)
            } else {
              setScrollColorChange(false)
            }
    
          }
          window.addEventListener("scroll", handleScroll)
          return () => {window.removeEventListener("scroll", handleScroll)}
        }, [])
  return (
    <section className='flex flex-col py-10 place-items-center'>
        <div className='w-full flex flex-col place-items-center pb-10'>
            <h1 className="text-4xl md:text-big-heading font-bold uppercase text-center tracking-tighter pb-6">{ContactCopy.title}</h1>
              <p className={`w-full md:w-[60%] text-[#6d6e73] text-medium md:text-xl md:text-[#f8f8ff] text-center px-5 leading-none md:leading-subheading transition-colors duration-500 ease-in-out ${scrollColorChange ? "md:text-black" : "md:text-white"}`}>{ContactCopy.subtitle}</p>
        </div>
        <div className='w-full md:w-[60%] md:pt-6'>
            <form ref={formRef} onSubmit={handleSubmit} className="space-y-2 ">
                <div className="space-y-2 ">
                    <label htmlFor="email" className="block text-lg text-[#6d6e73]">
                    Email address
                    </label>
                    <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    required
                    onChange={(e) => setFormEmail(e.target.value)}
                    className="w-full bg-[#ffffff] rounded-lg p-4 text-lg focus:ring-1 focus:ring-gray-400 placeholder:text-gray-400"
                    />
                </div>
                <div className="space-y-2">
                    <label htmlFor="message" className="block text-lg text-[#6d6e73]">
                    How can we help?
                    </label>
                    <textarea
                    id="message"
                    name="message"
                    placeholder="Enter your message"
                    onChange={(e) => setFormMessage(e.target.value)}
                    required
                    rows={6}
                    className="w-full bg-[#ffffff] rounded-lg p-4 text-lg border-0 focus:ring-1 focus:ring-gray-400 placeholder:text-gray-400 resize-none"
                    />
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-between space-y-6 sm:space-y-0 md:pt-5 ">
                    <button type="submit"
                            disabled={pending} 
                            className="font-bold bg-[#0b0d15] py-3 px-6 rounded-md hover:bg-[#892CDC] text-[#f8f8ff] cursor-pointer tracking-wide inline-flex items-center justify-center transition-all duration-300 ease-in-out disabled:opacity-50 disabled:hover:bg-gray-200 min-w-[180px] w-full sm:w-auto"
                            >
                                {pending ? (
                                    <Loader2 className="w-6 h-6 animate-spin" />
                                ) : (
                                    <>
                                    <span>Send Message</span>
                                    <ArrowRight className="w-6 h-6" />
                                    </>
                                )}
                    </button>
                </div>
            </form>
            <div className="relative">
                {(successMessage || errorMessage) && (
                <div className="flex items-start space-x-2 bg-[#ffffff] shadow-outline-gray text-white rounded-[9px] py-4 px-6 animate-fade-bottom absolute">
                    <div className="h-6 w-6 bg-[#00ff00] flex items-center justify-center rounded-full border border-[#00ff00] flex-shrink-0">
                    <FontAwesomeIcon icon={faCheck} className="fa-fw h-4 w-4" size="1x" />
                    </div>
                    <div className="text-xs sm:text-sm text-[#4B4C52] tracking-tight">
                    {successMessage ? (
                        <p>
                        We've received your request. We will reply to you asap!
                        </p>
                    ) : (
                        <p>
                        Oops. Message could not be sent.
                        </p>
                    )}
                    </div>
                    <XMarkIcon
                    className="h-5 w-5 cursor-pointer flex-shrink-0 text-[#4A4B55] font-bold"
                    onClick={dismissMessages}
                    />
                </div>
                )}
            </div>
        </div>

    </section>
  )
}

export default ContactForm